export default {
  startAddingToQueue: {
    en: 'Add {gender, select, female {perfume} male {cologne}} to your queue',
  },
}
